<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <Banner :competition="competition"></Banner>
    <template v-if="competitionStyle">
      <template v-if="!competitionStyle.templateId"></template>
      <template v-else>
        <template v-for="(component, index) in templateComponents">
          <component
            v-if="competitionStyle.templateId === ++index"
            :is="component"
            :key="index"
            :competition="competition"
            :competitionPlanList="competitionPlanList"
            :competitionResourceList="competitionResourceList"
            :competitionIntro="competitionIntro"
            :competitionFastEnterList="competitionFastEnterList"
            :competitionNewsList="competitionNewsList"
            :isCompetitionFastEnter="isCompetitionFastEnter"
            :iCompetitionNews="iCompetitionNews"
            :isCompetitionResource="isCompetitionResource"
            :competitionStyle="competitionStyle"
            :competitionFastEnters="competitionFastEnters"
            :competitionResources="competitionResources"
            @on-entrance="changeEntrance($event)"
          />
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import Banner from "@/components/banner";
import Template1 from "./components/template1";
import Template2 from "./components/template2";
import Template3 from "./components/template3";
import "@/style/quillEditor.css";
import { getCompetitionDetail, getExamUrl } from "../../api/index";

export default {
  name: "CompetitionDetail",
  components: { Banner, Template1, Template2, Template3 },

  data() {
    return {
      competitionPlanList: [], //赛事安排
      competitionResourceList: [], //资源下载
      competition: {}, //赛事基本信息
      competitionIntro: {}, //大赛介绍
      competitionFastEnterList: [], //快速入口
      competitionNewsList: [], //赛事公告
      isCompetitionFastEnter: false, //快速入口分页按钮
      iCompetitionNews: false, //赛事公告分页按钮
      isCompetitionResource: false, //资源下载分页按钮
      fullscreenLoading: false, //全局加载状态
      competitionStyle: {},

      competitionFastEnters: [], //快速入口 模板3专用
      competitionResources: [], //资源下载 模板3专用

      templateComponents: ["Template1", "Template2", "Template3"],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    sessionStorage.setItem("tabId", 1);
    this.getCompetitionDetail();
  },
  methods: {
    download(fileUrl) {
      window.location.href = fileUrl;
    },
    //快速入口跳转
    changeEntrance(item) {
      if (item.type === 2) {
        getExamUrl({
          competitionId: this.$route.query.competitionId,
          examId: item.extContent,
        }).then(({ data }) => {
          window.location.href = data;
        });
        return;
      }

      if (item.url.includes("http")) {
        window.open(item.url);
      } else {
        this.$router.push({
          path: item.url,
        });
      }
    },
    //赛事公告
    changeAnnouncement(item) {
      window.open(item.url);
    },
    //动态图标
    requireImageURL(iconType, name) {
      // 根据图标类型拼接图片路径
      return require(`@/resource/${name}-icon-${iconType}.png`);
    },
    //动态图标
    getImageURL(iconType, name) {
      // 根据图标类型拼接图片路径
      return require(`@/assets/${name}-icon-${iconType}.png`);
    },
    //将一个数组多少为一组组成二维数组
    chunkArray(arr, chunkSize) {
      const result = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
      }
      return result;
    },
    //赛事详情接口
    getCompetitionDetail() {
      let params = {
        competitionId: this.$route.query.competitionId,
      };
      this.fullscreenLoading = true;
      getCompetitionDetail(params)
        .then((res) => {
          this.fullscreenLoading = false;
          this.competition = res.data.competition;
          sessionStorage.setItem(
            "competition",
            JSON.stringify(res.data.competition)
          );
          this.competitionPlanList = res.data.competitionPlanList;
          this.competitionResourceList = res.data.competitionResourceList;
          this.competitionIntro = res.data.competitionIntro;
          this.competitionStyle = res.data.competitionStyle;
          this.competitionFastEnters = this.chunkArray(
            res.data.competitionFastEnterList,
            6
          );
          this.competitionResources = this.chunkArray(
            res.data.competitionResourceList,
            2
          );
          this.competitionFastEnterList = this.chunkArray(
            res.data.competitionFastEnterList,
            6
          );
          this.competitionNewsList = this.chunkArray(
            res.data.competitionNewsList,
            5
          );
          if (res.data.competitionFastEnterList.length > 6) {
            this.isCompetitionFastEnter = true;
          }
          if (res.data.competitionNewsList.length > 5) {
            this.iCompetitionNews = true;
          }
          if (res.data.competitionResourceList.length > 3) {
            this.isCompetitionResource = true;
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    scrollLeft(name) {
      const dataBar = document.querySelector(name);
      dataBar.scrollTo({
        left: dataBar.scrollLeft - dataBar.clientWidth,
        behavior: "smooth",
      });
    },

    scrollRight(name) {
      const dataBar = document.querySelector(name);
      dataBar.scrollTo({
        left: dataBar.scrollLeft + dataBar.clientWidth,
        behavior: "smooth",
      });
    },

    // calcBottomBorder(index) {

    // },
  },
};
</script>

<style lang="scss" scoped>
.msg::-webkit-scrollbar {
  display: none !important;
}
// .time {
//   font-size: 16px;
//   font-weight: 400;
//   color: #ffffff;
//   line-height: 22px;
//   margin-top: 20px;
// }
.line {
  display: flex;
  align-items: center;
  margin-top: 25px;
}
.left-line {
  width: 88px;
  height: 4px;
  background: #2f77ff;
}
.right-line {
  width: 89px;
  height: 4px;
  background: #2f77ff;
}
.dot {
  width: 20px;
  height: 20px;
  background: #2f77ff;
  border-radius: 50%;
}
.detail {
  display: flex;
  padding: 0 50px;
  margin-top: 62px;
}
.detail .img {
  padding-top: 42px;
}
.detail img {
  width: 52px;
  height: 52px;
  cursor: pointer;
}

.container {
  background: #171f30;
}
</style>
